import * as gs from "@ivanlog/gs";
import { CmpHeroVXBase } from "./tmpls";
import { BiMath } from "../libs/BiMath";
import { App } from "../App";

export class CmpHeroVX extends CmpHeroVXBase {

    constructor() {
        super();
        this.ctrls.lAPR.text="Loading"; 

        this.ctrls.btnInfo.onclick=()=>App.gui.dialogOkShowAsync(this.ctrls.lBtnInfo.text);
    }

    public async showAPR(vxAprBI:bigint)
    {
        const apr = BiMath.ToEth(vxAprBI);
        if (vxAprBI==BiMath.Zero) this.ctrls.lAPR.text="Calculating"; 
        else 
        {
            let acc=1;
            const daily = 1+parseFloat(apr)/365*0.91;
            for (let d=0;d<365;d++)
                acc = acc * daily;
            acc=acc-1;
            this.ctrls.lAPR.text = BiMath.TruncEth(BiMath.ToEth(BiMath.ToBI(acc+"")*BigInt(100)),3)+"%";
        }
    }
}